export default __webpack_public_path__ + "static/media/digital-signature.8faf8add.svg";